module.exports = __webpack_public_path__ + "img/help-content-3.ece721d4.png";